import Chart from 'chart.js/auto';
import {AlgoBase} from "./AlgoBase";
import {gsap} from "gsap/all";

export class KhronosChartJS extends AlgoBase {

  constructor(target) {
    super('khronos', target);
    this.init();
  }

  async init() {

    this.algortihmData = await this.buildDataset("data/algorithms/Khronos.csv");

    const ctx = this.$widget.find("canvas");

    this.chart = new Chart(ctx, {
      type: 'line',
      data: {
        labels: this.algortihmData.labels,
        datasets: [{
          label: 'Room Temperature', // [dynamic value in loadDataset()]
          data: this.algortihmData.mainDatasets[0],
          borderColor: '#000000',
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          annotation: {
            annotations: {
              line1: {
                type: 'line',
                title: "Heat setpoint", // [dynamic value in loadDataset()]
                yMin: 0, // [dynamic value in loadDataset()],
                yMax: 0,// [dynamic value in loadDataset()],
                borderColor: '#EB2B31',
                borderWidth: 1,
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              line2: {
                type: 'line',
                title: "Cold setpoint", // [dynamic value in loadDataset()],
                yMin: 0, // [dynamic value in loadDataset()],
                yMax: 0,// [dynamic value in loadDataset()],
                borderColor: '#205fb1',
                borderWidth: 1,
                borderDash: [4, 4],
                drawTime: 'beforeDraw',
                z: 1,
              },
              box1: {
                type: 'box',
                borderWidth: 0,
                xMin: 12, // [dynamic value in loadDataset()],
                xMax: 14, // [dynamic value in loadDataset()],
                backgroundColor: 'rgba(42, 255, 85, 0.30)',
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Savings", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => {
                    if (this.aiEnabled) this.drawLabelBackground(context, rect, 'rgb(195 245 197 / 0.8)')
                  }
                }
              },
              box2: {
                type: 'box',
                borderWidth: 0,
                xMin: 14, // [dynamic value in loadDataset()],
                xMax: 25, // [dynamic value in loadDataset()],
                backgroundColor: 'rgba(255, 180, 42 ,0.3)',
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Pre-occupancy runtime", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => this.drawLabelBackground(context, rect, 'rgb(245 222 187 / 0.8)')
                }
              },
              box3: {
                type: 'box',
                borderWidth: 0,
                xMin: 25,
                xMax: 45,
                // min: [dynamic value in loadDataset()],
                // max: [dynamic value in loadDataset()],
                backgroundColor: 'rgba(255, 42, 42, 0.3)',
                drawTime: 'beforeDraw',
                z: 0,
                label: {
                  display: true,
                  position: 'center',
                  drawTime: 'afterDraw',
                  z: 2,
                  rotation: -90,
                  content: "Building occupancy", // [dynamic value in loadDataset()],
                  color: '#000000',
                  font: Chart.defaults.plugins.annotation.common.label.font,
                  beforeDraw: (context, rect) => this.drawLabelBackground(context, rect, 'rgb(245 182 183 / 0.80)')
                }
              }
            }
          },
          legend: {
            labels: {
              usePointStyle: true,
              padding: 25,
            }
          },
          title: {
            display: true,
            text: 'OAT', // [dynamic value in loadDataset()],
          }
        },
        elements: {
          line: {
            tension: 0.3,
            borderColor: '#330808',
          }
        },
        scales: {
          x: this.setupXAxis(this.algortihmData.labels.length / 3),
          y: {
            // min: [dynamic value in loadDataset()],
            // max: [dynamic value in loadDataset()],
            ticks: {
              callback: (value, index, ticks) => {
                return this.temperatureLegend(value); // Append the unit
              }
            },
          }
        },
      },
    });

    this.loadDataset(0)

    this.initEvents();

    this.ready();
  }

  loadDataset(datasetIndex) {

    // This control the width of the annotations box
    // depending on the user input
    const savingStartTime = [
      14,
      16,
      18,
      22,
      24,
      24,
      22,
      20,
      17,
      14,
    ]

    // Important: we need to get the offset here too because otherwise the wrong dataset will be converted to celcius if needed
    const offset = (this.aiEnabled ? 0 : this.getLoopIndex());

    if (!this.aiEnabled) {
      // WITHOUT : Override original positions
      this.chart.options.plugins.annotation.annotations.box1.xMin = 12;
      this.chart.options.plugins.annotation.annotations.box1.xMax = 12;
      this.chart.options.plugins.annotation.annotations.box2.xMin = 12;
      this.chart.options.plugins.annotation.annotations.box1.label.color = 'rgba(0, 0, 0, 0)'; // 50% opaque text
    } else {
      // WITH : Restore original AI positions
      this.chart.options.plugins.annotation.annotations.box1.xMin = 12;
      this.chart.options.plugins.annotation.annotations.box1.xMax = savingStartTime[datasetIndex + offset];
      this.chart.options.plugins.annotation.annotations.box2.xMin = savingStartTime[datasetIndex + offset];
      this.chart.options.plugins.annotation.annotations.box1.label.color = 'rgba(0, 0, 0, 1)'; // 50% opaque text
    }

    this.chart.options.plugins.annotation.annotations.box1.display = true;

    // Update data for preferred unit
    this.algortihmData.mainDatasets[datasetIndex + offset] = this.convertDatasetToPreferredUnit(this.algortihmData.allDatasets[0][datasetIndex + offset])

    // Update y limits for preferred unit
    if (this.preferredUnit === "celsius") {
      this.chart.options.scales.y.min = 16
      this.chart.options.scales.y.max = 28
      this.chart.options.plugins.annotation.annotations.line1.yMax = this.fahrenheitToCelsius(67)
      this.chart.options.plugins.annotation.annotations.line2.yMax = this.fahrenheitToCelsius(74)
    } else {
      this.chart.options.scales.y.min = 60
      this.chart.options.scales.y.max = 80
      this.chart.options.plugins.annotation.annotations.line1.yMax = 67
      this.chart.options.plugins.annotation.annotations.line2.yMax = 74
    }

    // Synchronize annotations height with y limits
    this.chart.options.plugins.annotation.annotations.box1.yMin = this.chart.options.scales.y.min
    this.chart.options.plugins.annotation.annotations.box1.yMax = this.chart.options.scales.y.max
    this.chart.options.plugins.annotation.annotations.box2.yMin = this.chart.options.scales.y.min
    this.chart.options.plugins.annotation.annotations.box2.yMax = this.chart.options.scales.y.max
    this.chart.options.plugins.annotation.annotations.box3.yMin = this.chart.options.scales.y.min
    this.chart.options.plugins.annotation.annotations.box3.yMax = this.chart.options.scales.y.max

    // const box2HideLabel = (this.chart.options.plugins.annotation.annotations.box2.xMax - this.chart.options.plugins.annotation.annotations.box2.xMin < 3);
    // this.chart.options.plugins.annotation.annotations.box2.label.display = !box2HideLabel;

    // Keep annotation lines horizontal (flat)
    this.chart.options.plugins.annotation.annotations.line1.yMin = this.chart.options.plugins.annotation.annotations.line1.yMax
    this.chart.options.plugins.annotation.annotations.line2.yMin = this.chart.options.plugins.annotation.annotations.line2.yMax;

    // Update dynamic strings from CMS
    this.chart.data.datasets[0].label = this.getLegendFromCMS(3, 1);
    this.chart.options.plugins.annotation.annotations.line1.title = this.getLegendFromCMS(1, 1);
    this.chart.options.plugins.annotation.annotations.line2.title = this.getLegendFromCMS(2, 1);
    this.chart.options.plugins.annotation.annotations.box1.label.content = this.getLegendFromCMS(4, 1).toUpperCase();
    this.chart.options.plugins.annotation.annotations.box2.label.content = this.getLegendFromCMS(5, 1).toUpperCase();
    this.chart.options.plugins.annotation.annotations.box3.label.content = this.getLegendFromCMS(6, 1).toUpperCase();

    this.chart.options.plugins.title.text = this.getLegendFromCMS(7, 1)?.toUpperCase();

    // Here we need to pass the index without offset because it is already handled in the parent
    super.loadDataset(datasetIndex);
  }

}
